export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)} 万`;
  }
  return String(views);
}

const WEEK = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

export function formatDate(date: string): string {
  const d = new Date(`${date}T00:00:00`);
  if (Number.isNaN(d.getTime())) return date;
  return `${date} ${WEEK[d.getDay()]}`;
}